import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { TextBox, Button } from "devextreme-react";
import Utils from "Utils";
import { useUrlFilter } from "../../Hooks/utils";
import { StartupFilterForm } from "components/forms/StartupFilters"
import { InvestorFilterForm } from "components/forms/InvestorFilters"

function Filters(props) {
  const { disabled, type, showApplyButton, searchEnabled, formFields } = props;

  const initialStartupFilters = {
    city: null,
    country: null,
    ask_amount_gt: null,
    ask_amount_lt: null,
    industry: null,
    client_segment: null,
    sector: null,
    stage: null,
    status: null,
    text: null,
    deal_type: null,
    sort: null,
  };
  const initialInvestorFilters = {
    city: null,
    country: null,
    ticket_size_gt: null,
    ticket_size_lt: null,
    industries: null,
    client_segments: null,
    sector: null,
    preferred_stages: null,
    type: null,
    contact_person: null,
    status: null,
    text: null,
    sort: null,
  };

  const [filters, setFilters] = useUrlFilter();
  const [disableForm, setDisableForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [startupFilters, setStartupFilters] = useState(initialStartupFilters);
  const [investorFilters, setInvestorFilters] = useState(
    initialInvestorFilters
  );

  useEffect(() => {
    if (filters) {
      let newFilter = {};
      let setterFunc = null;

      if (type === "startup") {
        newFilter = { ...startupFilters };
        setterFunc = setStartupFilters;
      } else {
        newFilter = { ...investorFilters };
        setterFunc = setInvestorFilters;
      }

      Object.keys(filters).forEach((filter) => {
        newFilter[filter] = filters[filter];
      });
      setterFunc(newFilter);
    }
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    Utils.getFormFields();
  }, []);

  useEffect(() => {
    setDisableForm(disabled);
  }, [disabled]);

  const toggleFilter = () => {
    if (!disableForm) {
      setShowFilter(!showFilter);
    }
  };
  const handleFilter = (payload) => {
    var formData = payload;
    // removing the null object keys
    Object.keys(payload || {}).forEach(
      (key) => formData[key] == null && delete formData[key]
    );
    if (Object.keys(formData || {}).length) {
      setFilters(formData);
    }
  };
  const clearFilter = () => {
    if (type === "startup") {
      setStartupFilters(initialStartupFilters);
    } else {
      setInvestorFilters(initialInvestorFilters);
    }
    setFilters();
  };
  const searchHandler = (val) => {
    // setting value of text in investor and startup filter
    if (type === "startup") {
      startupFilters.text = val.value;
      setStartupFilters(startupFilters);
    } else {
      investorFilters.text = val.value;
      setInvestorFilters(investorFilters);
    }

    if (val.value.length) {
      setFilters({ text: val.value });
    } else {
      setFilters();
    }
  };
  const hitSearch = () => {
    handleFilter();
  };

  return (
    <>
      <div className={`flex ${showApplyButton ? "justify-center" : ""}`}>
        {searchEnabled && (
          <>
            <TextBox
              style={{ marginTop: 20 }}
              className="text-center"
              mode="search"
              height="25px"
              placeholder="Search..."
              stylingMode="underlined"
              value={
                type === "startup" ? startupFilters.text : investorFilters.text
              }
              onValueChanged={searchHandler}
              onEnterKey={hitSearch}
            />
            <Button
              stylingMode="text"
              icon={"search"}
              onClick={hitSearch}
              style={{ marginLeft: 15, marginRight: 15 }}
            />
          </>
        )}
        <button
          onClick={toggleFilter}
          style={{ marginBottom: 10 }}
          className={`btn btn-white btn-round btn-just-icon ${disableForm ? "cursor-disableForm" : ""
            }`}
          disableForm={disableForm}
        >
          <i
            className="fa fa-filter"
            style={{ color: showFilter ? "#9e56b0" : "" }}
          ></i>
          <div className="ripple-container"></div>
        </button>
      </div>
      <div className="row" style={{ padding: 10 }}>
        <div
          className="container"
          style={{
            display: showFilter && !disableForm ? "grid" : "none",
          }}
        >
          {type === "startup" ? (
            <StartupFilterForm
              data={startupFilters}
              dynamicFields={formFields}
              onSubmit={handleFilter}
              onReset={clearFilter}
              columns={6}
            />
          ) : (
            <InvestorFilterForm
              data={investorFilters}
              dynamicFields={formFields}
              onSubmit={handleFilter}
              onReset={clearFilter}
              columns={5}
            />
          )}
        </div>
      </div>
    </>
  );
}

Filters.defaultProps = {
  searchEnabled: true,
  disableForm: false,
  showApplyButton: true,
};

function mapStateToProps(state) {
  return {
    formFields: state.formFields,
  };
}

export default connect(mapStateToProps)(Filters);
